// alignment-stick-builder.js

(function () {
  const LENGTH_MM = { "40": 1016, "48": 1140 };

  const STRIPE_SPECS = {
    "40": { label: `40" Mid`, options: [
      { count: 5, gapMm: 36, stripesMm: [48, 36, 24, 36, 48], roles: ["p", "s", "a", "s", "p"] },
      { count: 7, gapMm: 36, stripesMm: [72, 24, 18, 18, 18, 24, 72], roles: ["p", "s", "a", "s", "a", "s", "p"] }
    ]},
    "48": { label: `48" Full Length`, options: [
      { count: 7, gapMm: 48, stripesMm: [84, 24, 18, 18, 18, 24, 84], roles: ["p", "s", "a", "s", "a", "s", "p"] },
      { count: 9, gapMm: 48, stripesMm: [48, 24, 18, 18, 18, 18, 18, 24, 48], roles: ["p", "s", "a", "p", "s", "p", "a", "s", "p"] }
    ]}
  };

  const PLACEHOLDERS = {
    p: "rgba(0,0,0,0.12)",
    s: "rgba(0,0,0,0.08)",
    a: "rgba(0,0,0,0.16)"
  };

  const PREVIEW_48_PX = 720;
  const PX_PER_MM = PREVIEW_48_PX / LENGTH_MM["48"];

  function extractHex(obj) {
    if (!obj) return null;
    const candidates = [
      obj.hex, obj.hexCode, obj.hex_code,
      obj.value, obj.colour, obj.color,
      obj.swatch, obj.swatchHex, obj.swatch_hex
    ];
    for (const c of candidates) {
      if (typeof c === "string") {
        const s = c.trim();
        if (/^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/.test(s)) return s;
      }
    }
    return null;
  }

  function cssSafeFont(font) {
    const f = String(font || "Inter").trim();
    if (f === "Helvetica") return `Helvetica, Arial, ui-sans-serif, system-ui, sans-serif`;
    if (f === "Times New Roman") return `"Times New Roman", Times, serif`;
    if (f === "Courier New") return `"Courier New", Courier, monospace`;
    if (f === "Trebuchet MS") return `"Trebuchet MS", Trebuchet, Arial, sans-serif`;
    if (f === "Brush Script MT") return `"Brush Script MT", "Comic Sans MS", cursive`;
    return `Inter, ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif`;
  }

  function initBuilder(root) {
    if (root.__tt_inited) return;
    root.__tt_inited = true;

    const $ = (sel) => root.querySelector(sel);

    const state = {
      length: "40",
      wood: "oak",
      stripeCount: 5,
      selected: { primary: null, secondary: null, accent: null },
      activeRole: "primary",
      colours: [],
      engraving: { enabled: false, text: "", font: "Inter" }
    };

    const els = {
      stripeOptions: $("#stripeOptions"),
      paletteWrap: $("#paletteWrap"),
      paletteGrid: $("#paletteGrid"),
      accentBlock: $("#accentBlock"),

      stickA: $("#stickA"),
      stickB: $("#stickB"),

      resetBtn: $("#resetBtn"),
      randomBtn: $("#randomBtn"),

      engraveNoBtn: $("#engraveNoBtn"),
      engraveYesBtn: $("#engraveYesBtn"),
      engraveFields: $("#engraveFields"),
      engraveText: $("#engraveText"),
      engraveFont: $("#engraveFont"),

      propLength: $("#tt_prop_length"),
      propWood: $("#tt_prop_wood"),
      propStripes: $("#tt_prop_stripes"),
      propPrimary: $("#tt_prop_primary"),
      propSecondary: $("#tt_prop_secondary"),
      propAccent: $("#tt_prop_accent"),
      propEngOn: $("#tt_prop_engraving_on"),
      propEngText: $("#tt_prop_engraving_text"),
      propEngFont: $("#tt_prop_engraving_font"),

      sumLength: $("#ttb_sum_length"),
      sumWood: $("#ttb_sum_wood"),
      sumStripes: $("#ttb_sum_stripes"),
      sumPrimary: $("#ttb_sum_primary"),
      sumSecondary: $("#ttb_sum_secondary"),
      sumAccent: $("#ttb_sum_accent"),
      sumEngraving: $("#ttb_sum_engraving")
    };

    function collapseStep(id) { const el = $(id); if (el) el.classList.add("ttb-step-collapsed"); }
    function expandStep(id) { const el = $(id); if (el) el.classList.remove("ttb-step-collapsed"); }

    function wireStepHeaderToggles() {
      root.querySelectorAll(".step").forEach((step) => {
        const header = step.querySelector(".stepHeader.ttb-stepToggle");
        if (!header) return;

        const setAria = () => {
          const expanded = !step.classList.contains("ttb-step-collapsed");
          header.setAttribute("aria-expanded", expanded ? "true" : "false");
        };

        header.addEventListener("click", (e) => {
          e.preventDefault();
          step.classList.toggle("ttb-step-collapsed");
          setAria();
        });

        header.addEventListener("keydown", (e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            step.classList.toggle("ttb-step-collapsed");
            setAria();
          }
        });

        setAria();
      });
    }

    function wireFaqAccordion() {
      const faq = root.querySelector("#ttbFaq");
      if (!faq) return;
      faq.querySelectorAll(".ttb-faqQ").forEach((btn) => {
        btn.addEventListener("click", () => btn.classList.toggle("is-open"));
      });
    }

    function getActiveSpec() {
      const group = STRIPE_SPECS[state.length];
      return group.options.find(o => o.count === state.stripeCount) || group.options[0];
    }

    function patternUsesAccent() {
      return getActiveSpec().roles.includes("a");
    }

    function updateAccentVisibility() {
      const use = patternUsesAccent();
      if (els.accentBlock) els.accentBlock.style.display = use ? "" : "none";
      if (!use) {
        state.selected.accent = null;
        const v = $("#accentValue");
        if (v) v.textContent = "—";
      }
    }

    function setRoleValueLabel(role, colour) {
      const el = $(`#${role}Value`);
      if (el) el.textContent = colour?.displayName || "—";
    }

    function setRoleOpen(role) {
      state.activeRole = role;
      root.querySelectorAll(".roleBlock").forEach(block => {
        const r = block.getAttribute("data-role");
        const open = (r === role);
        block.classList.toggle("is-open", open);
        block.classList.toggle("is-collapsed", !open);
      });

      const slot = root.querySelector(`.paletteSlot[data-slot="${role}"]`);
      if (slot && els.paletteWrap) slot.appendChild(els.paletteWrap);
    }

    function openNextRoleAfter(role) {
      if (role === "primary") return setRoleOpen("secondary");
      if (role === "secondary") {
        if (patternUsesAccent()) return setRoleOpen("accent");
        return;
      }
    }

    function toSelectedColour(c) {
      if (!c) return null;
      return { hex: c.hex || null, displayName: c.displayName || c.id || "", internalName: c.internalName || "" };
    }

    function colourForLetter(letter) {
      if (letter === "p") return state.selected.primary?.hex || PLACEHOLDERS.p;
      if (letter === "s") return state.selected.secondary?.hex || PLACEHOLDERS.s;
      if (letter === "a") return state.selected.accent?.hex || PLACEHOLDERS.a;
      return "transparent";
    }

    function endBlockMm(spec) {
      return spec.gapMm + spec.stripesMm.reduce((a,b)=>a+b,0);
    }

    function computeHeights(spec) {
      const stickMm = LENGTH_MM[state.length] || LENGTH_MM["48"];
      const stickPx = Math.round(stickMm * PX_PER_MM);
      const endMm = endBlockMm(spec);
      const patternPx = Math.max(60, Math.round(endMm * PX_PER_MM));
      return { stickPx, patternPx };
    }

    // ✅ Stripe logic exactly like the working version:
    // TOP: gap at cap, then stripes
    function buildGradientTop(spec) {
      const totalMm = endBlockMm(spec);
      const stops = [];

      const gapEndPct = (spec.gapMm / totalMm) * 100;
      stops.push(`rgba(0,0,0,0) 0%`, `rgba(0,0,0,0) ${gapEndPct}%`);

      let posMm = spec.gapMm;
      for (let i = 0; i < spec.stripesMm.length; i++) {
        const h = spec.stripesMm[i];
        const col = colourForLetter(spec.roles[i]);
        const fromPct = (posMm / totalMm) * 100;
        const toPct = ((posMm + h) / totalMm) * 100;
        stops.push(`${col} ${fromPct}%`, `${col} ${toPct}%`);
        posMm += h;
      }

      stops.push(`rgba(0,0,0,0) 100%`);
      return `linear-gradient(to bottom, ${stops.join(", ")})`;
    }

    // BOTTOM: reversed stripes, then gap at cap (end)
    function buildGradientBottom(spec) {
      const totalMm = endBlockMm(spec);
      const stops = [];

      let posMm = 0;
      for (let i = spec.stripesMm.length - 1; i >= 0; i--) {
        const h = spec.stripesMm[i];
        const col = colourForLetter(spec.roles[i]);
        const fromPct = (posMm / totalMm) * 100;
        const toPct = ((posMm + h) / totalMm) * 100;
        stops.push(`${col} ${fromPct}%`, `${col} ${toPct}%`);
        posMm += h;
      }

      const gapFromPct = (posMm / totalMm) * 100;
      stops.push(`rgba(0,0,0,0) ${gapFromPct}%`, `rgba(0,0,0,0) 100%`);

      return `linear-gradient(to bottom, ${stops.join(", ")})`;
    }

    function applyHeightsToStick(stickEl, stickPx, patternPx) {
      stickEl.style.setProperty("--ttb-stick-h", `${stickPx}px`);
      stickEl.style.setProperty("--ttb-pattern-h", `${patternPx}px`);
    }

    function updateWoodAvailabilityUI() {
      const jarrahBtn = root.querySelector('[data-wood="jarrah"]');
      const oakBtn = root.querySelector('[data-wood="oak"]');
      const hint = $("#woodHint");
      const jarrahAvailable = (state.length !== "48");

      if (jarrahBtn) {
        jarrahBtn.classList.toggle("is-disabled", !jarrahAvailable);
        jarrahBtn.disabled = !jarrahAvailable;
      }
      if (!jarrahAvailable && state.wood === "jarrah") {
        state.wood = "oak";
        root.querySelectorAll("[data-wood]").forEach(x => x.classList.remove("is-active"));
        oakBtn?.classList.add("is-active");
      }
      if (hint) {
        hint.textContent = jarrahAvailable
          ? "Choose your timber."
          : "WA Jarrah is currently out of stock for 48\" sticks.";
      }
    }

    function updateSticks() {
      const spec = getActiveSpec();
      const { stickPx, patternPx } = computeHeights(spec);

      [els.stickA, els.stickB].filter(Boolean).forEach(stick => {
        applyHeightsToStick(stick, stickPx, patternPx);

        const inner = stick.querySelector(".ttb-stick-inner");
        if (!inner) return;

        const top = inner.querySelector(".ttb-pattern-top");
        const bot = inner.querySelector(".ttb-pattern-bottom");
        const engr = inner.querySelector(".ttb-engrave");

        if (top) {
          top.style.height = `${patternPx}px`;
          top.style.setProperty("background-image", buildGradientTop(spec), "important");
        }
        if (bot) {
          bot.style.height = `${patternPx}px`;
          bot.style.setProperty("background-image", buildGradientBottom(spec), "important");
        }

        if (engr) {
          if (state.engraving.enabled) {
            engr.style.display = "";
            engr.style.fontFamily = cssSafeFont(state.engraving.font);
            engr.textContent = state.engraving.text || "";
          } else {
            engr.style.display = "none";
            engr.textContent = "";
          }
        }
      });
    }

    function updateSummary() {
      if (!els.sumLength) return;
      const safe = (v) => (v && String(v).trim().length ? String(v).trim() : "—");
      const engOn = (els.propEngOn?.value || "").toLowerCase() === "yes";
      const engText = safe(els.propEngText?.value || "");

      els.sumLength.textContent = safe(els.propLength?.value || "");
      els.sumWood.textContent = safe(els.propWood?.value || "");
      els.sumStripes.textContent = safe(els.propStripes?.value || "");
      els.sumPrimary.textContent = safe(els.propPrimary?.value || "");
      els.sumSecondary.textContent = safe(els.propSecondary?.value || "");
      els.sumAccent.textContent = safe(els.propAccent?.value || "");
      els.sumEngraving.textContent = engOn ? (engText !== "—" ? engText : "Yes") : "No";
    }

    function syncLineItemProperties() {
      if (els.propLength) els.propLength.value = STRIPE_SPECS[state.length]?.label || state.length;
      if (els.propWood) els.propWood.value = state.wood === "jarrah" ? "WA Jarrah" : "Tassie Oak";
      if (els.propStripes) els.propStripes.value = String(state.stripeCount || "");

      const fmt = (c) => {
        if (!c) return "";
        const name = c.displayName || "";
        const internal = c.internalName ? ` (${c.internalName})` : "";
        return `${name}${internal}`;
      };

      if (els.propPrimary) els.propPrimary.value = fmt(state.selected.primary);
      if (els.propSecondary) els.propSecondary.value = fmt(state.selected.secondary);
      if (els.propAccent) els.propAccent.value = fmt(state.selected.accent);

      if (els.propEngOn) els.propEngOn.value = state.engraving.enabled ? "Yes" : "No";
      if (els.propEngText) els.propEngText.value = state.engraving.enabled ? (state.engraving.text || "") : "";
      if (els.propEngFont) els.propEngFont.value = state.engraving.enabled ? (state.engraving.font || "Inter") : "";

      updateSummary();
    }

    function render() {
      updateWoodAvailabilityUI();
      updateAccentVisibility();
      updateSticks();
      setTimeout(updateSticks, 60);
      syncLineItemProperties();
    }

    async function loadColours() {
      const url = (window.TT_BUILDER && window.TT_BUILDER.colorsUrl) ? window.TT_BUILDER.colorsUrl : null;
      if (!url) throw new Error("Missing TT_BUILDER.colorsUrl");

      const res = await fetch(url, { cache: "no-store" });
      if (!res.ok) throw new Error("Could not load colours JSON.");

      const data = await res.json();
      let list = [];
      if (Array.isArray(data.colors)) list = data.colors;
      else if (Array.isArray(data.groups)) data.groups.forEach(g => (g.items || []).forEach(item => list.push(item)));

      return list.map((c, idx) => ({
        id: c.id || c.internalName || c.displayName || `c_${idx}`,
        displayName: c.displayName || c.name || c.internalName || `Colour ${idx + 1}`,
        internalName: c.internalName || "",
        hex: extractHex(c),
        available: (c.available !== false)
      }));
    }

    function buildPalette() {
      if (!els.paletteGrid) return;
      els.paletteGrid.innerHTML = "";

      state.colours.forEach(c => {
        if (c.available === false) return;
        const btn = document.createElement("button");
        btn.type = "button";
        btn.className = "swatchBtn";
        btn.setAttribute("data-colour-id", c.id);
        btn.title = c.displayName || c.id;
        btn.style.backgroundColor = c.hex || "#bdbdbd";
        els.paletteGrid.appendChild(btn);
      });
    }

    function wirePaletteClicks() {
      if (!els.paletteGrid) return;

      els.paletteGrid.addEventListener("click", (e) => {
        const btn = e.target.closest("[data-colour-id]");
        if (!btn) return;

        const id = btn.getAttribute("data-colour-id");
        const colour = state.colours.find(x => x.id === id);
        if (!colour) return;

        const role = state.activeRole || "primary";
        state.selected[role] = toSelectedColour(colour);
        setRoleValueLabel(role, state.selected[role]);

        openNextRoleAfter(role);
        render();

        if (role === "accent" || (role === "secondary" && !patternUsesAccent())) {
          collapseStep("#stepColours");
          expandStep("#stepEngraving");
        }
      });
    }

    function wireRoleHeaders() {
      root.querySelectorAll(".roleBlock .roleHeader").forEach(btn => {
        btn.addEventListener("click", () => {
          const role = btn.closest(".roleBlock")?.getAttribute("data-role");
          if (!role) return;
          if (role === "accent" && !patternUsesAccent()) return;
          setRoleOpen(role);
        });
      });
    }

    function wireLengthButtons() {
      root.querySelectorAll("[data-length]").forEach(btn => {
        btn.addEventListener("click", () => {
          const length = btn.getAttribute("data-length");
          if (!length) return;

          state.length = length;

          root.querySelectorAll("[data-length]").forEach(x => x.classList.remove("is-active"));
          btn.classList.add("is-active");

          const group = STRIPE_SPECS[state.length];
          state.stripeCount = group.options[0].count;

          state.selected.primary = null;
          state.selected.secondary = null;
          state.selected.accent = null;
          setRoleValueLabel("primary", null);
          setRoleValueLabel("secondary", null);
          setRoleValueLabel("accent", null);

          setRoleOpen("primary");
          renderStripeOptions();

          collapseStep("#stepLength");
          expandStep("#stepWood");

          render();
        });
      });
    }

    function wireWoodButtons() {
      root.querySelectorAll("[data-wood]").forEach(btn => {
        btn.addEventListener("click", () => {
          if (btn.disabled) return;

          const wood = btn.getAttribute("data-wood");
          if (!wood) return;

          state.wood = wood;

          root.querySelectorAll("[data-wood]").forEach(x => x.classList.remove("is-active"));
          btn.classList.add("is-active");

          collapseStep("#stepWood");
          expandStep("#stepStripes");

          render();
        });
      });
    }

    function renderStripeOptions() {
      const group = STRIPE_SPECS[state.length];
      if (!els.stripeOptions) return;

      els.stripeOptions.innerHTML = "";
      group.options.forEach(opt => {
        const b = document.createElement("button");
        b.type = "button";
        b.className = "segBtn" + (opt.count === state.stripeCount ? " is-active" : "");
        b.textContent = `${opt.count} stripes`;
        els.stripeOptions.appendChild(b);

        b.addEventListener("click", () => {
          state.stripeCount = opt.count;

          state.selected.primary = null;
          state.selected.secondary = null;
          state.selected.accent = null;
          setRoleValueLabel("primary", null);
          setRoleValueLabel("secondary", null);
          setRoleValueLabel("accent", null);

          [...els.stripeOptions.querySelectorAll(".segBtn")].forEach(x => x.classList.remove("is-active"));
          b.classList.add("is-active");

          setRoleOpen("primary");

          collapseStep("#stepStripes");
          expandStep("#stepColours");

          render();
        });
      });
    }

    function wireEngraving() {
      if (els.engraveNoBtn) els.engraveNoBtn.addEventListener("click", () => {
        state.engraving.enabled = false;
        if (els.engraveFields) els.engraveFields.classList.add("is-hidden");
        render();
      });

      if (els.engraveYesBtn) els.engraveYesBtn.addEventListener("click", () => {
        state.engraving.enabled = true;
        if (els.engraveFields) els.engraveFields.classList.remove("is-hidden");
        render();
      });

      if (els.engraveText) {
        els.engraveText.addEventListener("input", () => {
          state.engraving.text = (els.engraveText.value || "").slice(0, 20);
          render();
        });
      }

      if (els.engraveFont) {
        els.engraveFont.addEventListener("change", () => {
          state.engraving.font = els.engraveFont.value || "Inter";
          render();
        });
      }
    }

    function wireResetRandom() {
      if (els.resetBtn) els.resetBtn.addEventListener("click", () => {
        state.length = "40";
        state.wood = "oak";
        state.stripeCount = 5;

        state.selected.primary = null;
        state.selected.secondary = null;
        state.selected.accent = null;
        setRoleValueLabel("primary", null);
        setRoleValueLabel("secondary", null);
        setRoleValueLabel("accent", null);

        state.engraving.enabled = false;
        state.engraving.text = "";
        if (els.engraveText) els.engraveText.value = "";
        if (els.engraveFields) els.engraveFields.classList.add("is-hidden");

        root.querySelectorAll("[data-length]").forEach(x => x.classList.remove("is-active"));
        root.querySelector('[data-length="40"]')?.classList.add("is-active");

        root.querySelectorAll("[data-wood]").forEach(x => x.classList.remove("is-active"));
        root.querySelector('[data-wood="oak"]')?.classList.add("is-active");

        expandStep("#stepLength");
        collapseStep("#stepWood");
        collapseStep("#stepStripes");
        collapseStep("#stepColours");
        collapseStep("#stepEngraving");

        renderStripeOptions();
        setRoleOpen("primary");
        render();
      });

      if (els.randomBtn) els.randomBtn.addEventListener("click", () => {
        const available = state.colours.filter(c => c.available !== false);
        const pick = () => available[Math.floor(Math.random() * available.length)] || null;

        state.selected.primary = toSelectedColour(pick());
        state.selected.secondary = toSelectedColour(pick());
        state.selected.accent = patternUsesAccent() ? toSelectedColour(pick()) : null;

        setRoleValueLabel("primary", state.selected.primary);
        setRoleValueLabel("secondary", state.selected.secondary);
        setRoleValueLabel("accent", state.selected.accent);

        render();
      });
    }

    async function boot() {
      expandStep("#stepLength");
      collapseStep("#stepWood");
      collapseStep("#stepStripes");
      collapseStep("#stepColours");
      collapseStep("#stepEngraving");

      renderStripeOptions();
      updateAccentVisibility();
      updateWoodAvailabilityUI();
      setRoleOpen("primary");

      wireStepHeaderToggles();
      wireFaqAccordion();
      wirePaletteClicks();
      wireRoleHeaders();
      wireLengthButtons();
      wireWoodButtons();
      wireEngraving();
      wireResetRandom();

      try {
        state.colours = await loadColours();
        buildPalette();
      } catch (e) {
        console.error(e);
      }

      render();
    }

    boot();
  }

  function bootAll() {
    document.querySelectorAll(".tt-builder").forEach(initBuilder);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bootAll);
  } else {
    bootAll();
  }

  document.addEventListener("shopify:section:load", bootAll);
})();